import React from 'react'
import { groups } from 'd3-array'

export const categoryTitles: { [K in categoriesT]: string } = {
  dangers: 'Bedenken wegen der Gefahren',
  effectiveness: 'Bedenken wegen der Wirksamkeit',
  need: 'Bedenken wegen der Notwendigkeit',
  others: 'Sonstige Bedenken'
}

const qanda: QandAT[] = [
  {
    name: 'Clara V.',
    info: '37, Geografin, Kanton Bern',
    question: (
      <>
        Letztes Jahr wurde immer wieder betont, die Entwicklung und Erprobung
        eines sicheren Impfstoffs dauere Jahre. Warum sollte das jetzt nicht
        mehr gelten?
      </>
    ),
    answer: (
      <>
        Dass es eine Pandemie brauchte, damit Regierungen die nötigen
        finanziellen Risiken eingingen – Risiken, die die Pharmabranche nie
        eingehen würde –, das ist in der Tat unverständlich. Dank ihrer
        Milliarden konnten nun aber alle Phasen der Impfstoffentwicklung
        parallel stattfinden. Üblicherweise wird auf den Erfolg einer Phase
        gewartet, bevor man die nächste beginnen kann. Es wurden Fabriken für
        Impfstoffe gebaut, bevor man überhaupt wusste, ob der betreffende
        Impfstoff wirksam sein würde! Eine solche Situation ist ohne eine
        schwere Pandemie undenkbar.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Nathalie J.',
    info: '38, Ärztin Dr. med., Kanton Bern',
    question: (
      <>
        Ich werde mich vorerst nicht impfen lassen. Dies aus folgendem Grund:
        Die Behörde rät davon ab, den Impfstoff Menschen abzugeben, die in den
        vergangenen drei Monaten eine Corona-Infektion durchgemacht haben. Das
        Problem: Viele Verläufe sind asymptomatisch. Das heisst, es werden
        zwangsläufig Menschen geimpft werden, die eigentlich nicht geimpft
        werden sollten.
      </>
    ),
    answer: (
      <>
        Ich verstehe, dass die Kommunikation diesbezüglich verwirrend war. In
        Wirklichkeit ist eine Impfung aber auch dann kein Risiko, wenn man
        kürzlich an Covid erkrankt ist. Einige Studien haben sich genau dieser
        Frage angenommen, und die kürzlich erkrankten Probanden hatten keine
        Probleme mit der Impfung. Allerdings kann man nach einer Infektion drei
        Monate abwarten, weil der Schutz vor einer neuerlichen Infektion
        mindestens so lange anhält. Das Zuwarten ist aber keine Notwendigkeit.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Olivia Y.',
    info: '62, Ärztin Dr.med., Kanton Zürich',
    question: (
      <>
        Zu mRNA-Impfstoffen wird seit 1990 geforscht, etwa gegen Krebs,
        Influenza, HIV, Ebola, Zika oder Tollwut. Offenbar waren die Impfstoffe
        bisher nicht erfolgreich, oder sie zeigten andere Probleme. Warum
        sollten wir ihnen jetzt ganz plötzlich vertrauen?
      </>
    ),
    answer: (
      <>
        Hätten die Regierungen bereits früher so viel Geld in die Hand genommen
        wie jetzt gegen die Pandemie hätten wir heute Impfstoffe gegen viele
        Krankheiten und zudem wirksamere Impfstoffe gegen die Grippe. Das ist
        so. Der mRNA-Impfstoff machte bisher allerdings noch nie Probleme –
        ausser dass er nicht effektiv genug war! Dank öffentlicher Gelder
        konnten die Pharmaunternehmen nun Dutzende von Impfstoffkandidaten
        miteinander vergleichen und den wirksamsten auswählen. Ich bin mir
        sicher, dass uns diese Technologie endlich neue und bessere Impfstoffe
        ermöglichen wird.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Heidi W.',
    info: '60, Buchhalterin, Kanton Wallis',
    question: (
      <>
        Der Biontech/Pfizer-Impfstoff greift in die Genstruktur ein, und man
        weiss immer noch nicht, wie das genau funktioniert. Deshalb lasse ich
        mich nicht impfen.
      </>
    ),
    answer: (
      <>
        Gelangten Gene aus einem Impfstoff in meine Gene, würde mir das auch
        Sorgen machen. Das ist beim mRNA-Impfstoff aber nicht der Fall. Der
        Impfstoff gelangt vielmehr in den Teil der Muskelzellen und in die
        weissen Blutkörperchen. Diese «denken», dass es sich um ein Virus
        handle, und aktivieren das Immunsystem. Der Impfstoff kann gar nicht in
        den Kern der Zellen eindringen, wo sich unsere Gene, unsere DNA,
        befinden. Der Impfstoff ist also kein Risiko für unsere DNA. Die mRNA
        wird etwa zwei Tage lang in Protein übersetzt, dann wird sie zerstört.
        Das ist genau derselbe Prozess, der bei einer Infektion – egal ob Covid,
        Grippe, oder Erkältung – abläuft. Milliarden viraler mRNA-Moleküle
        gelangen in unsere Zellen. Sie verändern aber nicht unsere eigenen Gene.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Tim Q.',
    info: '57, Angestellter im Gesundheitswesen, Kanton Zürich',
    question: (
      <>
        Was jetzt passiert, ist ein Feldversuch am Menschen. Das mache ich nicht
        mit. Wir impfen die Menschen mit einer Teilerbinformation des
        Coronavirus, und der Mensch produziert dieses Protein dann selbst in der
        Hoffnung, dass unser Immunsystem dagegen wirkt. Was genau passiert, kann
        aber niemand erklären. Denn wir wissen ja nicht, in welche Körperzellen
        diese Proteine aufgenommen werden.
      </>
    ),
    answer: (
      <>
        Was nach der Injektion passiert, ist heute zum Glück viel besser bekannt
        als noch vor ein paar Monaten. Erwiesen ist auch, dass das Immunsystem
        sehr gut reagiert. Dass die Impfungen sehr effektiv – konkret 95% der
        Impfungen – gegen Covid-19 schützen.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Tom Z.',
    info: '52, Musiker, Kanton Zürich',
    question: (
      <>
        Dass die Pharmakonzerne die Verantwortung für Folgeschäden auf den Staat
        abwälzen, zeigt, dass sie hohe Haftungskosten nicht ausschliessen.
        Deshalb lasse ich mich frühestens in einem Jahr impfen, wenn man sieht,
        wie es den ersten Geimpften ergangen ist.
      </>
    ),
    answer: (
      <>
        Wenn die Pharmaunternehmen nicht verantwortlich gemacht werden könnten,
        wäre das tatsächlich schockierend. Zum Glück ist das aber nicht so. Die
        Pharmaunternehmen bleiben zu 100 Prozent verantwortlich für alle
        Herstellungsfehler und alle Probleme, die während der Entwicklung des
        Impfstoffs auftreten können. Die einzige Verantwortung, die die
        Regierungen übernehmen, ist folgende: die Entschädigung für den Fall,
        dass nach der Impfung eine schwere, aber seltene Nebenwirkung auftritt.
        Die Regierungen haben diese Mitverantwortung akzeptiert, damit der
        Impfstoff schneller hergestellt werden kann. Ohne diese Vereinbarung
        müssten wir jetzt noch auf einen Impfstoff warten.
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Cynthia Y.',
    info: ' 40, Selbständige, Kanton Bern',
    question: (
      <>
        Ich leide am Mastzellaktivierungssyndrom und an Allergien. Impfungen
        können bei diesen Vorerkrankungen starke allergische Reaktionen und
        langfristige Verschlechterungen der chronischen Erkrankung auslösen.
        Daher möchte ich das Risiko dieser Impfung nicht eingehen.
      </>
    ),
    answer: (
      <>
        Dieses Argument kann ich sehr gut nachvollziehen. Zumal sie noch jung
        und ansonsten hoffentlich gesund sind!
      </>
    ),
    type: 'dangers'
  },
  {
    name: 'Ignaz Y.',
    info: ' 61, Informatiker, Kanton Solothurn',
    question: (
      <>
        Ich lasse mich nicht impfen, weil ich weitere Mutationen des Virus
        erwarte und ich nicht glaube, dass der Impfstoff einen anhaltenden
        Schutz bietet – im Gegensatz zu einer durchgemachten Erkrankung.
      </>
    ),
    answer: (
      <>
        Noch wissen wir nicht, wie lange die Impfstoffe schützen. Das stimmt.
        Was wir aber leider bereits wissen: dass die Immunität nach einer
        Infektion nicht lange anhält. Aber wenn Sie, Ihre Familie und Freunde
        gesund sind, besteht keine Eile, sich impfen zu lassen. Sie können
        abwarten, bis diese Informationen bekannt sind.
      </>
    ),
    type: 'effectiveness'
  },
  {
    name: 'Brigitte W.',
    info: '58, Lehrerin, Kanton Zürich',
    question: (
      <>
        Obwohl ich zur Risikogruppe zähle, lasse ich mich nicht impfen, solange
        nicht feststeht, ob der Impfschutz auch die Weiterverbreitung des Virus
        verhindert. Ob der Impfstoff dies kann oder nicht, ist für mich die
        Gretchenfrage.
      </>
    ),
    answer: (
      <>
        Für junge und gesunde Menschen ist der Schutz ihrer Liebsten tatsächlich
        der wichtigste Impfgrund. Ob der Impfschutz das Virus hindert, sich zu
        verbreiten, können wir bis jetzt nur hoffen. Garantieren können wir es
        aber noch nicht. Nehmen Sie sich also Zeit, bis Sie überzeugt sind.
      </>
    ),
    type: 'effectiveness'
  },
  {
    name: 'Helena X.',
    info: '27, Veterinärmedizinerin, Kanton Aargau',
    question: (
      <>
        Ich lasse mich nicht impfen, weil noch grundsätzliche Fragen offen sind.
        Etwa, wie lange und gut der Schutz ist oder ob man trotzdem noch
        ansteckend ist. Bei einer Impfung sollte immer das Risiko von
        unerwünschten Wirkungen mit dem Schweregrad der Krankheit verglichen
        werden. Dies ist hier noch nicht möglich, zudem erwarte ich als junge
        Person einen milden Covid-Verlauf, falls es mich treffen sollte.
      </>
    ),
    answer: (
      <>
        Die Antwort auf die vorherige Frage von Brigitte W. gilt umso mehr, wenn
        sie von einer 27-Jährigen gestellt wird!
      </>
    ),
    type: 'effectiveness'
  },
  {
    name: 'Clara C.',
    info: ' 48, Lehrerin, Kanton Basel Stadt',
    question: (
      <>
        Ich habe eine Corona-Erkrankung durchgemacht und sehe daher keinen
        Grund, mich impfen zu lassen.
      </>
    ),
    answer: (
      <>
        Ich hoffe, die Krankheit war nicht ernst oder langwierig. Dann ist es
        umso besser für Sie, dass Sie die Infektion durchgemacht haben. Doch
        leider wissen wir, dass der Schutz nach der Erkrankung allmählich
        abnimmt. Aber Sie sind ja noch jung, da drängt die Entscheidung nicht.
      </>
    ),
    type: 'need'
  },
  {
    name: 'Sara W.',
    info: '38, Managerin, Kanton Graubünden',
    question: (
      <>
        Ich bin 38, gesund und eigentlich nie krank. Weshalb sollte ich mich
        impfen lassen? Würde es nicht reichen, wenn sich die Risikopersonen
        impfen lassen und wir gesunden Personen uns quasi durchseuchen lassen
        würden?
      </>
    ),
    answer: (
      <>
        Für Junge wie Sie ist der Hauptgrund für die Impfung, andere zu
        schützen. Hier wissen wir aber wie gesagt noch nicht ganz genau, wie die
        Impfung funktioniert. Nehmen Sie sich ruhig die Zeit!
      </>
    ),
    type: 'need'
  },
  {
    name: 'Xaver F.',
    info: '48, Architekt, Kanton Zürich',
    question: (
      <>
        Die Gefahr einer Überlastung des Gesundheitssystems lässt sich
        entschärfen, wenn man nun ältere und gefährdete Menschen sowie
        Pflegepersonal impft. Bei allen anderen sehe ich keinen triftigen Grund
        dafür. Der Nutzen einer Impfung ist für Jüngere sehr gering, da nur ein
        verschwindend kleiner Teil von ihnen schwer erkrankt. Auf der anderen
        Seite sind deren mögliche Langzeitwirkungen noch unbekannt.
      </>
    ),
    answer: (
      <>
        Sie haben recht: Für diejenigen, die jung und gesund sind, besteht keine
        Eile. Denn erstens gibt es noch nicht genug Impfstoff für alle. Und
        zweitens werden in einigen Monaten neue Daten zur Sicherheit des
        Impfstoffs vorliegen. Diese Daten werden es für alle viel einfacher
        machen, sich zu entscheiden.
      </>
    ),
    type: 'need'
  },
  {
    name: 'Clemens W.',
    info: '64, Banker, Kanton Zug',
    question: (
      <>
        Ich bin kein Impfgegner. Was mich aber misstrauisch macht: Warum sollen
        unter 16-Jährige nicht geimpft werden? In der Vergangenheit wurden
        Impfungen auch Kindern verabreicht.
      </>
    ),
    answer: (
      <>
        Die Entwicklung eines Impfstoffs wird zuerst immer auf Erwachsene
        ausgerichtet. Dann geht es um die Jugendlichen und zuletzt um die
        Kinder. So bekommen wir bessere Möglichkeiten, eine Krankheit zu
        bekämpfen. Bei Covid wäre die Impfung von Kindern – die ja fast nie
        ernsthaft erkranken – nur dann sinnvoll, wenn man das Virus komplett
        loswerden wollte. Das ist derzeit aber weder möglich noch das Ziel.
      </>
    ),
    type: 'others'
  },
  {
    name: 'Guido Y.',
    info: '57, Unternehmer, Kanton Zürich',
    question: (
      <>
        Ich misstraue der Kühlkette. Ich befürchte, dass der Impfstoff von
        Pfizer nicht jederzeit mit den nötigen tiefen Temperaturen gekühlt
        werden kann. Daher lasse ich mich zumindest mit diesem Impfstoff nicht
        impfen.
      </>
    ),
    answer: (
      <>
        Die Kühlkette zum Schutz von mRNA-Impfstoffen, sie ist tatsächlich eine
        mühsame Angelegenheit. Doch was passiert, wenn dieser Impfstoff sich
        erwärmt? Die mRNA würde schnell zerstört, und der Impfstoff verlöre
        seine Wirkung. Er hätte schlicht keine Wirkung mehr: keine positive,
        aber auch keine negative. Zum Glück dürfte der Impfstoff von Moderna
        bald verfügbar sein. Diesen kann man einen Monat lang im Kühlschrank
        aufbewahren.
      </>
    ),
    type: 'others'
  }
]

export const questionsAndAnswers = groups(qanda, d => d.type)
